class JoinCalculator extends HTMLElement {
  constructor() {
    super();

    this.baseRates = JSON.parse(this.querySelector('[data-join-calculator="json"]').textContent);
    const updateRates = this.baseRates.rates.map(({ratemonthly, ratereferral, ...rest}) => {
      ratemonthly = ratemonthly / 100;
      ratereferral = ratereferral / 100;

      return {...rest, ratemonthly, ratereferral}
    });

    this.rates = updateRates.sort((a,b) => b.minsale - a.minsale);


    /* example
    this.rates = [
      {minsale: 800, ratemonthly: 0.30, ratereferral: 0.08, title: 'Mylee Maker'},
      {minsale: 500, ratemonthly: 0.25, ratereferral: 0.07, title: 'Mylee Pro'},
      {minsale: 200, ratemonthly: 0.20, ratereferral: 0.06, title: 'Mylee Rising'},
      {minsale: 100, ratemonthly: 0.15, ratereferral: 0.05, title: 'Mylee Starter'},
    ];
    */

    this.elements = {
      rangePersonal: this.querySelector('[data-join-calculator="personalRange"]'),
      rangeReferrals: this.querySelector('[data-join-calculator="referralsRange"]'),
      valuePersonal: this.querySelector('[data-join-calculator="personalValue"]'),
      valueReferrals: this.querySelector('[data-join-calculator="referralsValue"]'),
      totalSale: this.querySelector('[data-join-calculator="total"]'),
    };

    this.onInput = this.handleInput.bind(this);
  }

  connectedCallback() {
    this.addEventListener('input', this.onInput);
    this.updateUI();
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.onInput);
  }

  handleInput(event) {
    const target = event.target;
    if (!target.name) return;

    const element = this.querySelector(`[data-join-calculator="${target.name}"]`);
    if (element) this.updateRangeBackground(element);

    this.updateUI();
  }

  updateRangeBackground(element) {
    const percentage = (element.value / element.max) * 100;
    element.style.background = `linear-gradient(to right, rgb(var(--global-color-accent)) ${percentage}%, #fff ${percentage}%)`;
  }

  updateUI() {
    const { rangePersonal, rangeReferrals, valuePersonal, valueReferrals, totalSale } = this.elements;

    const personalSales = Number(rangePersonal.value);
    const referrals = Number(rangeReferrals.value);

    valuePersonal.textContent = personalSales;
    valueReferrals.textContent = referrals;

    const rate = this.getRate(personalSales);
    const personalEarnings = personalSales * rate.ratemonthly;
    const referralEarnings = referrals * 200 * rate.ratereferral;
    const totalEarnings = personalEarnings + referralEarnings;

    totalSale.textContent = totalEarnings.toFixed(2);
  }

  getRate(sales) {
    const foundRate = this.rates.find(rate => sales >= rate.minsale);
    return foundRate || {ratemonthly: 0, ratereferral: 0, title: 'Not eligible'};
  }
}

customElements.define('join-calculator', JoinCalculator);
